import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  discountTimestampRangeService,
  getDiscountTimestampRangeService, // Changed to the new service
} from "redux/services/products_sevice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const DiscountTimeModal = ({ isOpen, onClose, campaign }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { discountRangeTime } = useSelector((state) => state.products);

  const [formData, setFormData] = useState({
    start_discount_timestamp: discountRangeTime?.start_discount_timestamp,
    end_discount_timestamp: discountRangeTime?.end_discount_timestamp,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (campaign) {
      setFormData({
        start_discount_timestamp: discountRangeTime?.start_discount_timestamp || "",
        end_discount_timestamp: discountRangeTime?.end_discount_timestamp || "",
      });
    } else {
      setFormData({
        start_discount_timestamp: "",
        end_discount_timestamp: "",
      });
    }
    setErrors({});
  }, [campaign, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.start_discount_timestamp) {
      newErrors.start_discount_timestamp = t("startDateRequired");
    }
    if (!formData.end_discount_timestamp) {
      newErrors.end_discount_timestamp = t("endDateRequired");
    }
    if (formData.start_discount_timestamp && formData.end_discount_timestamp) {
      if (
        new Date(formData.start_discount_timestamp) >=
        new Date(formData.end_discount_timestamp)
      ) {
        newErrors.end_discount_timestamp = t("endDateMustBeAfterStart");
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatTimestamp = (datetimeLocal) => {
    // Convert "2026-01-01T23:15" to "2026-01-01 23:15:00"
    return datetimeLocal.replace("T", " ") + ":00";
  };

  const handleSave = () => {
    if (!validateForm()) return;

    const data = {
      start_discount_timestamp: formatTimestamp(
        formData.start_discount_timestamp
      ),
      end_discount_timestamp: formatTimestamp(formData.end_discount_timestamp),
    };

    dispatch(discountTimestampRangeService(data)).then((response) => {
      if (
        response?.payload?.status === 200 ||
        response?.payload?.status === 201
      ) {
        toast(t("savedSuccessfully"));
        onClose();
      } else {
        toast(t("errorSaving"));
      }
    });
  };

  useEffect(() => {
    dispatch(getDiscountTimestampRangeService());
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              {campaign ? t("editDiscountPeriod") : t("setDiscountPeriod")}
            </h2>
          </div>
          <button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                وقت البدأ
              </label>

          
              <input
                type="datetime-local"
                value={formData.start_discount_timestamp}
                onChange={(e) =>
                  handleInputChange("start_discount_timestamp", e.target.value)
                }
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {errors.start_discount_timestamp && (
                <p className="text-sm text-red-600 mt-1">
                  {errors.start_discount_timestamp}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                وقت الانتهاء
              </label>
              <input
                type="datetime-local"
                value={formData.end_discount_timestamp}
                onChange={(e) =>
                  handleInputChange("end_discount_timestamp", e.target.value)
                }
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {errors.end_discount_timestamp && (
                <p className="text-sm text-red-600 mt-1">
                  {errors.end_discount_timestamp}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-6 border-t border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-2">
            <button className="mr-4 ml-4" variant="ghost" onClick={onClose}>
              {t("cancel")}
            </button>
            <Button onClick={handleSave}>
              {campaign ? t("updateDiscountPeriod") : t("setDiscountPeriod")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountTimeModal;
